/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
import useTranslate from "../../../app/hooks/useTranslate";
const API_URL = process.env.REACT_APP_API_URL;
const SETTINGS_BASE_URL = `${API_URL}/settings`;
const PLATFORM_SETTINGS_URL = `${SETTINGS_BASE_URL}/platform`;
const INSTAGRAM_UPLOAD_URL = `${SETTINGS_BASE_URL}/instagram/upload`;
const FACEBOOK_UPLOAD_URL = `${SETTINGS_BASE_URL}/facebook/upload`;
const UPDATE_PLAYER_FREE_ACCESS = `${SETTINGS_BASE_URL}/update-player-access`;


export const getSettings = createAsyncThunk(
  "settings/getSettings",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(SETTINGS_BASE_URL);
      return data;
    } catch (error: any) {
      const msg = error?.response?.data?.responseMessage || error.message;
      notify(msg, "error");
      return rejectWithValue(msg);
    }
  }
);

export const savePlatformSettings = createAsyncThunk(
  "settings/savePlatformSettings",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(PLATFORM_SETTINGS_URL, payload);
      notify(data.responseMessage, "success");
      dispatch(getSettings());
      return data;
    } catch (error: any) {
      const msg = error?.response?.data?.responseMessage || error.message;
      notify(msg, "error");
      return rejectWithValue(msg);
    }
  }
);

export const uploadVideoToInstagram = createAsyncThunk(
  "settings/uploadVideoToInstagram",
  async (videoData: any, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(INSTAGRAM_UPLOAD_URL, videoData);
      notify(data.responseMessage, "success");
      return data;
    } catch (error: any) {
      const msg = error?.response?.data?.responseMessage || error.message;
      notify(msg, "error");
      return rejectWithValue(msg);
    }
  }
);

export const uploadVideoToFacebook = createAsyncThunk(
  "settings/uploadVideoToFacebook",
  async (videoData: any, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(FACEBOOK_UPLOAD_URL, videoData);
      notify(data.responseMessage, "success");
      return data;
    } catch (error: any) {
      const msg = error?.response?.data?.responseMessage || error.message;
      notify(msg, "error");
      return rejectWithValue(msg);
    }
  }
);


export const updatePlayerFreeAccess = createAsyncThunk(
  "updatePlayerFreeAccess",
  async (values: any, { rejectWithValue }) => {
    try {
       const { isPlayerFreeAccess, t } = values;

      const { data } = await axios.post(
        UPDATE_PLAYER_FREE_ACCESS,   // <-- your API endpoint constant
        { isPlayerFreeAccess }
      );

      notify(t("FREE_ACCESS_UPDATE_MESSAGE"), "success");

      return data;
    } catch (error: any) {      
      const { responseMessage } = error?.response?.data || {};
      notify(responseMessage || "Something went wrong", "error");

      return rejectWithValue(error.message);
    }
  }
);
